import { createApp } from 'vue'
import { asyncHandleInstance } from 'app_alegra_commons/config'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import routes from '@/vue/router/router'
import '../node_modules/@alegradev/smile-ui-next/dist/style.css'
import './index.css'

import * as Sentry from '@sentry/vue'

import ENV from '../environment.json'
import { canBeMounted } from '@/vue/utils/appHelpers'

const app = createApp(App)

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DNS,
  environment: process.env.VUE_APP_ENVIROMENT.toUpperCase(),
  integrations: [Sentry.browserTracingIntegration({ router: routes }), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/hopper\.alegra\.com/, /^https:\/\/app\.alegra\.com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    "Cannot read properties of null (reading 'sessionId')",
    'Qr is null',
    "null is not an object (evaluating 'Qr.sessionId')",
    "Cannot read properties of null (reading 'version')",
    'Loading CSS chunk 89 failed',
    'Unhandled Ocurrió un problema al procesar su petición',
    'Event `Event` (type=error) captured as promise rejection',
    'Object captured as exception with keys: message',
    'captureException',
  ],
})

app.use(routes)
app.use(VueQueryPlugin)
asyncHandleInstance(app, {})

if (canBeMounted()) {
  app.mount('#app')
} else {
  const ENVIROMENT = String(process.env.VUE_APP_ENVIROMENT).toLowerCase()
  ;(window as any).location = `${ENV[ENVIROMENT]['BASE_URL']}user/login`
}
